export const FormGroup = ({ children }: any) => {
  return (
    <div className='form-group-dsg'>
      {children}
    </div>
  );
};
